import { render } from "./Octave.vue?vue&type=template&id=73c6ffb7&scoped=true"
import script from "./Octave.vue?vue&type=script&lang=ts"
export * from "./Octave.vue?vue&type=script&lang=ts"

import "./Octave.vue?vue&type=style&index=0&id=73c6ffb7&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-73c6ffb7"

export default script